import React from "react";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import "./_accordion-item.scss";
import ChevronIcon from '../../../assets/icons/chevron-down.svg';
import {OrganisationContactItem} from "../../../../types/ApiTypeDefinition/singleClubFinderResultTypes";

const baseClass = 'accordion-item';

interface PropTypes {
  accordionTitle: string
  demographicsList?: {
    gender: string,
    ageFrom?: string,
    ageTo?: string
  }[]
  iconBeforeText: any
  sessionsList?: any
  organisationContactItems?: OrganisationContactItem[]
}

const AccordionItem = (props: PropTypes): JSX.Element => {
  let accordionDetail;

  const getFormattedTime = (inputTime: string) => {
    const formattedTime = new Date(`2000-01-01T${inputTime}`).toLocaleTimeString('en-AU', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
    return formattedTime;
  }

  if (props.demographicsList && props.demographicsList.length > 0) {
    accordionDetail = props.demographicsList.map((demographicDetail: any, index: number) =>
      <div className={`${baseClass}--demographic-detail`} key={index}>
        <div className={'demographic-range'}>{demographicDetail.ageFrom} - {demographicDetail.ageTo}</div>
        <div className={'label-text'}>{demographicDetail.gender}</div>
      </div>
    );
  } else if (props.sessionsList && props.sessionsList.length > 0) {
    accordionDetail = props.sessionsList.map((sessionsDetail: any, index: number) =>
      <div className={`${baseClass}--demographic-detail`} key={index}>
        <div className={'label-text'}>{sessionsDetail.day}</div>
        <div className={'demographic-range'}>{getFormattedTime(sessionsDetail.startTime)} - {getFormattedTime(sessionsDetail.endTime)}</div>
      </div>
    );
  } else if (props.organisationContactItems && props.organisationContactItems.length > 0) {
    accordionDetail = props.organisationContactItems.map((contact: OrganisationContactItem, index: number) =>
      <div className={`${baseClass}--organisation-contact ${index > 0 ? 'add-divider' : ''}`} key={index}>
        <div className={'label-text position'}>{contact.position ? contact.position.split('_').join(" ").toLowerCase() : '-'}</div>
        <div className={'label-text name'}>{contact.firstName ? contact.firstName : '-'} {contact.lastName ? contact.lastName : ''}</div>
        <div className={'contact-info'}>
          <div className={'label-text email'}><a href={`mailto:${contact.email ? contact.email : ''}`}>{contact.email ? contact.email : ''}</a></div>
          <div className={'label-text phone'}><a href={`tel:${contact.phone ? contact.phone : ''}`}>{contact.phone ? contact.phone : ''}</a></div>
        </div>
      </div>
    );
  }

  return (
    <div className={`${baseClass}`}>
      <Accordion>
        <AccordionSummary
          className={`${baseClass}--accordion-summary`}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography className={`${baseClass}--typography`}> <img src={props.iconBeforeText}/> {props.accordionTitle} <img
            className={'chevron-icon'} src={ChevronIcon}/></Typography>
        </AccordionSummary>
        <AccordionDetails className={props.organisationContactItems && props.organisationContactItems.length > 0 ? `${baseClass}--orgContact` : ''}>
          {accordionDetail}
        </AccordionDetails>
      </Accordion>
    </div>
  )
}

export default AccordionItem;
